'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Select = require('../Select');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var PaginationOptions = function (_Component) {
  _inherits(PaginationOptions, _Component);

  function PaginationOptions(props) {
    _classCallCheck(this, PaginationOptions);

    var _this = _possibleConstructorReturn(this, (PaginationOptions.__proto__ || Object.getPrototypeOf(PaginationOptions)).call(this, props));

    _this.onSelect = function (v) {
      var onPageSizeChange = _this.props.onPageSizeChange;

      onPageSizeChange && onPageSizeChange(v);
    };

    return _this;
  }
  // componentWillReceiveProps(nextProps: Object) {
  //   const { pageSize } = nextProps;
  //   console.log(nextProps);
  //   // this.setState({ value: current });
  // }

  _createClass(PaginationOptions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          pageSizeOptions = _props.pageSizeOptions,
          pageSize = _props.pageSize,
          current = _props.current,
          total = _props.total,
          showTextWithOnlyOneOption = _props.showTextWithOnlyOneOption;

      var defaultValue = pageSize ? pageSize : Number(pageSizeOptions[0]);
      var startItem = total > 0 ? (Number(current) - 1) * Number(pageSize) + 1 : 0;
      var endItem = total > 0 ? Number(current) * Number(pageSize) : 0;

      var _disabledSelect = pageSizeOptions.length === 1 && showTextWithOnlyOneOption;

      return _react2.default.createElement(
        'div',
        { className: 'pagination-content pagination-options' },
        _react2.default.createElement(
          _Select.Select,
          {
            kind: 'text',
            size: 'default',
            placeholder: 'Choose one',
            className: 'pageSizeChanger',
            onSelect: this.onSelect,
            disabled: _disabledSelect,
            defaultValue: defaultValue
          },
          pageSizeOptions.map(function (option, i) {
            var value = Number(option);
            return _react2.default.createElement(
              _Select.SelectOption,
              { key: i, value: value },
              value + ' / page'
            );
          })
        ),
        _react2.default.createElement(
          'span',
          { className: 'show-total-text' },
          startItem,
          ' - ',
          endItem > Number(total) ? total : endItem,
          ' of ',
          total,
          ' ',
          'items'
        )
      );
    }
  }]);

  return PaginationOptions;
}(_react.Component);

PaginationOptions.displayName = 'PaginationOptions';

exports.default = PaginationOptions;